import React, { Component, Suspense, lazy } from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import Spinner from "../components/shared/Common/spinner";
import GuardedRoute from "./GuardedRoute";

// const Detection = lazy(() => import("../components/Pages/Events/event"));
const DetectionV2 = lazy(() => import("../components/Pages/Events/eventV2"));

// const Restriction = lazy(() => import("../components/Pages/Restrictions/restriction"));
const RestrictionV2 = lazy(() => import("../components/Pages/Restrictions/restrictionV2"));

// const Audit = lazy(() => import("../components/Pages/Logs/audit"));
const AuditV2 = lazy(() => import("../components/Pages/Logs/auditV2"));

// const Traffic = lazy(() => import("../components/Pages/Traffic/traffic"));
const TrafficV2 = lazy(() => import("../components/Pages/Traffic/trafficV2"));

// const Users = lazy(() => import("../components/Pages/Users/users"));
const UsersV2 = lazy(() => import("../components/Pages/Users/usersV2"));

// const Visibility = lazy(() => import("../components/Pages/Visibility/saas"));
const VisibilityV2 = lazy(() => import("../components/Pages/Visibility/saasV2"));
const SaasDetails = lazy(() => import("../components/Pages/Visibility/SaasDetails.jsx"));

// const Extensions = lazy(() => import("../components/Pages/Visibility/ext"));
// const ExtensionsV2 = lazy(() => import("../components/Pages/Visibility/extV2"));

const ExtensionApps = lazy(() => import("../components/Pages/Extensions/Extensions"));
const ExtensionDetails = lazy(() => import("../components/Pages/Extensions/ExtensionsDetails"));

const Contractors = lazy(() => import("../components/Pages/Contractors/Contractors"));

// const OverView = lazy(() => import("../components/Pages/OverView/overView"));
// const OverViewV2 = lazy(() => import("../components/Pages/OverView/OverviewV2"));
const Certificates = lazy(() => import("../components/Pages/Certificate/certificates"));
const Installers = lazy(() => import("../components/Pages/Installers/InstallerPageV2"));
const Policy = lazy(() => import("../components/Pages/Policy/policy"));
const Login = lazy(() => import("../components/Pages/Login/login"));
const Ldap = lazy(() => import("../components/Pages/Config/Ldap/ldap"));
const Backup = lazy(() => import("../components/Pages/Config/Backup/backup"));
const Authentication = lazy(() => import("../components/Pages/Config/Authentication/auth"));
const PolicyObj = lazy(() => import("../components/Pages/Config/PolicyObj/policy_objects"));
const Siem = lazy(() => import("../components/Pages/Config/Siem/siem"));
const Sso = lazy(() => import("../components/Pages/Config/Sso/sso"));
const Pac = lazy(() => import("../components/Pages/Config/Pac/pac"));
const Brand = lazy(() => import("../components/Pages/Config/Brand/brand"));
const Admins = lazy(() => import("../components/Pages/Config/Admins/admins"));
const Uptime = lazy(() => import("../components/Pages/Uptime/Uptime"));
const BrowserHealthOverview = lazy(()=> import("../components/Pages/BrowserHealth/Browsers"));
const BrowserHealthDetail = lazy(()=> import("../components/Pages/BrowserHealth/BrowserHealthDetail"));

const OverviewRoute = lazy(() => import("./OverviewRoute"));
const BrowserPolicyRoute = lazy(() => import("./BrowserPolicyRoute"));

// deprecated routes 
// "/policy",
// "/policy/proxy",
// "/policy/appcontrol",
// "/policy/ignoreurl",
// "/policy/blockurl",
class AppRoutes extends Component {
    render() {
        return (
            <Suspense fallback={<Spinner />}>
                <Switch>
                    {<Route exact path="/overview" component={OverviewRoute} />}
                    {/* {<Route exact path="/events/detection" component={DetectionV2} />} */}
                    {<Route exact path="/events" component={DetectionV2} />}
                    {<Route exact path="/events/restriction" component={RestrictionV2} />}
                    {<Route exact path="/certificates" component={Certificates} />}
                    {<Route exact path={["/policy/browser", "/policy/browser_pr"]} component={BrowserPolicyRoute} />}
                    {<GuardedRoute exact path={[
                        "/policy/urlfilter",
                        "/policy/filescan",
                        "/policy/cdr",
                        "/policy/dlp",
                        "/policy/ext",
                        "/policy/awareness",
                        "/policy/accesscontrol"
                    ]} component={Policy} />}
                    {<GuardedRoute exact path="/license/users" component={UsersV2} />}
                    {<GuardedRoute exact path="/config/ldap" component={Ldap} />}
                    {<Route exact path="/config/backup" component={Backup} />}
                    {<GuardedRoute exact path="/config/auth" component={Authentication} />}
                    {<Route exact path="/config/pol_objects" component={PolicyObj} />}
                    {<Route exact path="/config/siem" component={Siem} />}
                    {<Route exact path="/config/sso" component={Sso} />}
                    {<GuardedRoute exact path="/license/installers" component={Installers} />}
                    {<GuardedRoute exact path="/config/pac" component={Pac} />}
                    {<Route exact path="/config/brand" component={Brand} />}
                    {<Route exact path="/config/admins" component={Admins} />}
                    {<GuardedRoute exact path="/config/uptime" component={Uptime} />}
                    {<GuardedRoute exact path="/visibility/saas" component={VisibilityV2} />}
                    {<GuardedRoute exact path="/visibility/saas/:id" component={SaasDetails} />}
                    {<GuardedRoute exact path="/visibility/ext" component={ExtensionApps} />}
                    {<GuardedRoute exact path="/visibility/ext/:id" component={ExtensionDetails} />}
                    {<GuardedRoute exact path="/contractors" component={Contractors} />}
                    {<Route exact path="/logs/audit" component={AuditV2} />}
                    {<GuardedRoute exact path="/browser-health/detail" component={BrowserHealthDetail} />}
                    {<GuardedRoute exact path="/browser-health" component={BrowserHealthOverview} />}
                    {<Route exact path="/" component={OverviewRoute} />}
                    {<Route exact path="/login" component={Login} />}

                    <Redirect to="/" />
                </Switch>
            </Suspense>
        );
    }
}

export default AppRoutes;
